<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"545px"'
    :cpntOnFecharDialog='dfExpFormFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="cpntId === 0 || cpntId.length === 1 && cpntId[0] === 0">
        Nova Exportação de Documentos Fiscais
      </template>
      <template v-else-if="cpntId >= 1 || cpntId.length === 1 && cpntId[0] >= 1">
        Edição da Exportação de Documentos Fiscais - {{ cpntId >= 1 ? cpntId : cpntId[0] }}
      </template>
    </template>      

    <template slot='conteudo'>
      <div class="df-exp-form">
        <div>
          <App-Calendario :data-time="time" :class="campos.per_ini.id"
          :cpntStatus='campos.per_ini.status'
          :cpntId='campos.per_ini.id'
          :cpntTabIndex='campos.per_ini.tabIndex'
          :cpntClassDivField='campos.per_ini.classDivField'
          :cpntNome='campos.per_ini.nome'
          :cpntValue='campos.per_ini.value'
          :cpntAutoComplete='campos.per_ini.autocomplete'
          :cpntMask='campos.per_ini.mask'
          :cpntDisabled='campos.per_ini.disabled'
          :cpntMostrar='campos.per_ini.mostrar'
          :cpntAutoFocus='campos.per_ini.autofocus'
          :cpntMensagem='campos.per_ini.mensagem'
          :cpntMensagemTipo='campos.per_ini.mensagemTipo'
          :cpntPlaceholder='campos.per_ini.placeholder'
          :cpntPosicionar='campos.per_ini.posicionar'
          :cpntOnChange='campos.per_ini.onChange'
          ref='per_ini'
          ></App-Calendario>

          <App-Calendario :data-time="time" :class="campos.per_fin.id"
          :cpntStatus='campos.per_fin.status'
          :cpntId='campos.per_fin.id'
          :cpntTabIndex='campos.per_fin.tabIndex'
          :cpntClassDivField='campos.per_fin.classDivField'
          :cpntNome='campos.per_fin.nome'
          :cpntValue='campos.per_fin.value'
          :cpntAutoComplete='campos.per_fin.autocomplete'
          :cpntMask='campos.per_fin.mask'
          :cpntDisabled='campos.per_fin.disabled'
          :cpntMostrar='campos.per_fin.mostrar'
          :cpntAutoFocus='campos.per_fin.autofocus'
          :cpntMensagem='campos.per_fin.mensagem'
          :cpntMensagemTipo='campos.per_fin.mensagemTipo'
          :cpntPlaceholder='campos.per_fin.placeholder'
          :cpntPosicionar='campos.per_fin.posicionar'
          :cpntOnChange='campos.per_fin.onChange'
          ref='per_fin'
          ></App-Calendario>
        </div>

        <div>
          <App-Chosen-Tab :data-time="time" :class="campos.id_con.id"
          :cpntStatus="campos.id_con.status"
          :cpntId='campos.id_con.id'
          :cpntNome="campos.id_con.nome"
          :cpntValue="campos.id_con.value"
          :cpntFraseBtTodos="campos.id_con.fraseBtTodos"
          :cpntKeyValue='campos.id_con.keyValue'
          :cpntKeyMostra='campos.id_con.keyMostra'
          :cpntKeyMostraTab='campos.id_con.keyMostraTab'
          :cpntNewOption='campos.id_con.newOption'
          :cpntMensagem='campos.id_con.mensagem'

          :cpntRouter='campos.id_con.router'
          :cpntMethod='campos.id_con.method'
          :cpntField='campos.id_con.field'
          :cpntFieldVirtual='campos.id_con.fieldVir'
          :cpntWhere='campos.id_con.where'

          :cpntOnChange='campos.id_con.onChange'
          ref="id_con"
          ></App-Chosen-Tab>
        </div>

        <div>
          <App-Chosen-Tab :data-time="time" :class="campos.id_des.id"
          :cpntStatus="campos.id_des.status"
          :cpntId='campos.id_des.id'
          :cpntNome="campos.id_des.nome"
          :cpntValue="campos.id_des.value"
          :cpntFraseBtTodos="campos.id_des.fraseBtTodos"
          :cpntKeyValue='campos.id_des.keyValue'
          :cpntKeyMostra='campos.id_des.keyMostra'
          :cpntKeyMostraTab='campos.id_des.keyMostraTab'
          :cpntNewOption='campos.id_des.newOption'
          :cpntMensagem='campos.id_des.mensagem'

          :cpntRouter='campos.id_des.router'
          :cpntMethod='campos.id_des.method'
          :cpntField='campos.id_des.field'
          :cpntFieldVirtual='campos.id_des.fieldVir'
          :cpntWhere='campos.id_des.where'
          
          :cpntOnChange='campos.id_des.onChange'
          ref="id_des"
          ></App-Chosen-Tab>

          <!-- <App-Toggles :data-time="time" :class="campos.contador.id"
          :cpntStatus='campos.contador.status'
          :cpntId='campos.contador.id'
          :cpntClassDivField='campos.contador.classDivField'
          :cpntNome='campos.contador.nome'
          :cpntValue='campos.contador.value'
          :cpntMostrar='campos.contador.mostrar'
          :cpntMensagem='campos.contador.mensagem'
          :cpntMensagemTipo='campos.contador.mensagemTipo'
          :cpntOn='campos.contador.on'
          :cpntOff='campos.contador.off'
          :cpntExplica='campos.contador.explica'
          :cpntWidth='campos.contador.width'
          :cpntTabIndex='campos.contador.tabIndex'
          :cpntDisabled='campos.contador.disabled'
          :cpntOnChange='campos.contador.onChange'
          :cpntOnBlur='campos.contador.onBlur'
          ref='contador'
          ></App-Toggles> -->
        </div>

        <div>
          <App-Toggles :data-time="time" :class="campos.xml.id"
          :cpntStatus='campos.xml.status'
          :cpntId='campos.xml.id'
          :cpntClassDivField='campos.xml.classDivField'
          :cpntNome='campos.xml.nome'
          :cpntValue='campos.xml.value'
          :cpntMostrar='campos.xml.mostrar'
          :cpntMensagem='campos.xml.mensagem'
          :cpntMensagemTipo='campos.xml.mensagemTipo'
          :cpntOn='campos.xml.on'
          :cpntOff='campos.xml.off'
          :cpntExplica='campos.xml.explica'
          :cpntWidth='campos.xml.width'
          :cpntTabIndex='campos.xml.tabIndex'
          :cpntDisabled='campos.xml.disabled'
          :cpntOnChange='campos.xml.onChange'
          :cpntOnBlur='campos.xml.onBlur'
          ref='xml'
          ></App-Toggles>

          <App-Toggles :data-time="time" :class="campos.pdf.id"
          :cpntStatus='campos.pdf.status'
          :cpntId='campos.pdf.id'
          :cpntClassDivField='campos.pdf.classDivField'
          :cpntNome='campos.pdf.nome'
          :cpntValue='campos.pdf.value'
          :cpntMostrar='campos.pdf.mostrar'
          :cpntMensagem='campos.pdf.mensagem'
          :cpntMensagemTipo='campos.pdf.mensagemTipo'
          :cpntOn='campos.pdf.on'
          :cpntOff='campos.pdf.off'
          :cpntExplica='campos.pdf.explica'
          :cpntWidth='campos.pdf.width'
          :cpntTabIndex='campos.pdf.tabIndex'
          :cpntDisabled='campos.pdf.disabled'
          :cpntOnChange='campos.pdf.onChange'
          :cpntOnBlur='campos.pdf.onBlur'
          ref='pdf'
          ></App-Toggles>

          <App-Toggles :data-time="time" :class="campos.relatorio.id"
          :cpntStatus='campos.relatorio.status'
          :cpntId='campos.relatorio.id'
          :cpntClassDivField='campos.relatorio.classDivField'
          :cpntNome='campos.relatorio.nome'
          :cpntValue='campos.relatorio.value'
          :cpntMostrar='campos.relatorio.mostrar'
          :cpntMensagem='campos.relatorio.mensagem'
          :cpntMensagemTipo='campos.relatorio.mensagemTipo'
          :cpntOn='campos.relatorio.on'
          :cpntOff='campos.relatorio.off'
          :cpntExplica='campos.relatorio.explica'
          :cpntWidth='campos.relatorio.width'
          :cpntTabIndex='campos.relatorio.tabIndex'
          :cpntDisabled='campos.relatorio.disabled'
          :cpntOnChange='campos.relatorio.onChange'
          :cpntOnBlur='campos.relatorio.onBlur'
          ref='relatorio'
          ></App-Toggles>
        </div>
        
        <div>
          <App-Input :data-time="time" :class="campos.password.id"
          :cpntStatus='campos.password.status'
          :cpntId='campos.password.id'
          :cpntType='campos.password.type'
          :cpntTabIndex='campos.password.tabIndex'
          :cpntClassDivField='campos.password.classDivField'
          :cpntNome='campos.password.nome'
          :cpntValue='campos.password.value'
          :cpntAutoComplete='campos.password.autocomplete'
          :cpntMask='campos.password.mask'
          :cpntOptionInicialNome='campos.password.optionInicialNome'
          :cpntOptionInicialValue='campos.password.optionInicialValue'
          :cpntDisabled='campos.password.disabled'
          :cpntMostrar='campos.password.mostrar'
          :cpntExplica='campos.password.explica'
          :cpntAutoFocus='campos.password.autofocus'
          :cpntMensagem='campos.password.mensagem'
          :cpntMensagemTipo='campos.password.mensagemTipo'
          :cpntPlaceholder='campos.password.placeholder'
          :cpntPosicionar='campos.password.posicionar'
          :cpntOnChange='campos.password.onChange'
          :cpntOnBlur='campos.password.onBlur'
          ref='password'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" :class="campos.assunto.id"
          :cpntStatus='campos.assunto.status'
          :cpntId='campos.assunto.id'
          :cpntTabIndex='campos.assunto.tabIndex'
          :cpntClassDivField='campos.assunto.classDivField'
          :cpntNome='campos.assunto.nome'
          :cpntValue='campos.assunto.value'
          :cpntAutoComplete='campos.assunto.autocomplete'
          :cpntMask='campos.assunto.mask'
          :cpntOptionInicialNome='campos.assunto.optionInicialNome'
          :cpntOptionInicialValue='campos.assunto.optionInicialValue'
          :cpntDisabled='campos.assunto.disabled'
          :cpntMostrar='campos.assunto.mostrar'
          :cpntExplica='campos.assunto.explica'
          :cpntAutoFocus='campos.assunto.autofocus'
          :cpntMensagem='campos.assunto.mensagem'
          :cpntMensagemTipo='campos.assunto.mensagemTipo'
          :cpntPlaceholder='campos.assunto.placeholder'
          :cpntPosicionar='campos.assunto.posicionar'
          :cpntOnChange='campos.assunto.onChange'
          :cpntOnBlur='campos.assunto.onBlur'
          ref='assunto'
          ></App-Input>
        </div>

        <div>
          <App-Ckeditor :data-time="time" :class="campos.conteudo.id"
          :cpntStatus='campos.conteudo.status'
          :cpntId='campos.conteudo.id'
          :cpntClassDivField='campos.conteudo.classDivField'
          :cpntNome='campos.conteudo.nome'
          :cpntValue='campos.conteudo.value'
          :cpntAutoComplete='campos.conteudo.autocomplete'
          :cpntDisabled='campos.conteudo.disabled'
          :cpntMostrar='campos.conteudo.mostrar'
          :cpntMensagem='campos.conteudo.mensagem'
          :cpntMensagemTipo='campos.conteudo.mensagemTipo'
          :cpntConfig='campos.conteudo.config'
          :cpntExplica='campos.conteudo.explica'
          :cpntTabIndex='campos.conteudo.tabIndex'

          :cpntOnChange='campos.conteudo.onChange'
          :cpntOnBlur='campos.conteudo.onBlur'
          ref='conteudo'
          ></App-Ckeditor>
        </div>
        
      </div>
    </template>

    <template slot='rodape'>
      <div class="df-exp-form--botoes">
        <App-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>

        <App-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.df-exp-form {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .df-exp-form > div:not(:first-child) {
    padding-top: 22px;
  }
  .df-exp-form > div,
  .df-exp-form > div > div {
    width: 100%;
  }

  .df-exp-form > div > .df-exp-form--per_ini,
  .df-exp-form > div > .df-exp-form--per_fin {
    width: calc(50% - 5px);
  }
  /* .df-exp-form > div > .df-exp-form--id_des {
    width: calc(100% - 125px - 10px);
  }
  .df-exp-form > div > .df-exp-form--contador {
    width: 125px;
  } */
  .df-exp-form > div > .df-exp-form--xml,
  .df-exp-form > div > .df-exp-form--pdf,
  .df-exp-form > div > .df-exp-form--relatorio {
    width: calc((100% / 3) - (20px / 3));
  }

  .df-exp-form > div > .df-exp-form--xml,
  .df-exp-form > div > .df-exp-form--pdf,
  .df-exp-form > div > .df-exp-form--per_ini,
  .df-exp-form > div > .df-exp-form--id_des {
    margin-right: 10px;
  }

  .df-exp-form > div > .df-exp-form--contador,
  .df-exp-form > div > .df-exp-form--xml,
  .df-exp-form > div > .df-exp-form--pdf,
  .df-exp-form > div > .df-exp-form--relatorio,
  .df-exp-form > div > .df-exp-form--conteudo  {
    margin-bottom: 0px;
  }

  .df-exp-form--botoes {
    text-align: right;
  }
    .df-exp-form--botoes > button {
      margin: 0px 4px;
    }
    .df-exp-form--botoes > button:last-child {
      margin-right: 0px;
    }
</style>

<style>
  .df-exp-form > div > .df-exp-form--contador > div.toggle,
  .df-exp-form > div > .df-exp-form--xml > div.toggle,
  .df-exp-form > div > .df-exp-form--pdf > div.toggle,
  .df-exp-form > div > .df-exp-form--relatorio > div.toggle {
    width: 100% !important;
  }
</style>

<script>
export default {
  props: {
    cpntId: {
      required: false,
      default: function () {
        return 0
      }
    },
    cpntFecharFormulario: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  components: {
    'App-Ckeditor': () => import('@/components/rf-geral/ckeditor/RF-Ckeditor.vue')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      campos: {
        per_ini: {
          id: 'df-exp-form--per_ini',
          status: '',
          nome: 'Período Inicial',
          value: '',
          apiEnv: 'per_ini',
          onChange: this.dfExpFormOnChangeValue
        },
        per_fin: {
          id: 'df-exp-form--per_fin',
          status: '',
          nome: 'Período Final',
          value: '',
          apiEnv: 'per_fin',
          onChange: this.dfExpFormOnChangeValue
        },
        id_con: {
          id: 'df-exp-form--id_con',
          status: '',
          nome: 'Clientes',
          keyValue: 'id',
          keyMostra: [ 'nome', ' | ', 'cnpj_cpf', ' | ', 'email' ],
          keyMostraTab: [ 'nome', 'cnpj_cpf', 'email' ],
          router: '/contato/get',
          method: 'POST',
          field: { id: null, nome: null, cnpj_cpf: null, email: null },
          where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' } ] },
          apiEnv: 'id_con',
          multiple: true,
          fraseBtTodos: 'Todos',
          newOption: {
            tipo: 'icone',
            icone: { tipo: 'ico-mais' },
            explica: { titulo: '', mensagem: 'Adicionar novo cliente' },
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            onClick: () => { this.dfExpFormOnNovoContato('id_con') }
          },
          mostrar: true,
          value: '__TODOS__',
          onChange: this.dfExpFormOnChangeValue
        },
        id_des: {
          id: 'df-exp-form--id_des',
          status: '',
          nome: 'Destinatário',
          keyValue: 'id',
          keyMostra: [ 'nome', ' | ', 'cnpj_cpf', ' | ', 'email' ],
          keyMostraTab: [ 'nome', 'cnpj_cpf', 'email' ],
          router: '/contato/get',
          method: 'POST',
          field: { id: null, nome: null, cnpj_cpf: null, email: null },
          where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' } ] },
          apiEnv: 'id_des',
          multiple: true,
          fraseBtTodos: '',
          newOption: {
            tipo: 'icone',
            icone: { tipo: 'ico-mais' },
            explica: { titulo: '', mensagem: 'Adicionar novo destinatário' },
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            onClick: () => { this.dfExpFormOnNovoContato('id_des') }
          },
          mostrar: true,
          value: [],
          onChange: this.dfExpFormOnChangeValue
        },
        contador: {
          id: 'df-exp-form--contador',
          status: '',
          nome: 'Enviar ao contador?',
          mostrar: true,
          value: true,
          onChange: this.dfExpFormOnChangeValue
        },

        xml: {
          id: 'df-exp-form--xml',
          status: '',
          nome: 'Enviar no e-mail',
          mostrar: true,
          value: true,
          on: 'XML',
          off: '---',
          apiEnv: 'xml',
          onChange: this.dfExpFormOnChangeValue
        },
        pdf: {
          id: 'df-exp-form--pdf',
          status: '',
          nome: '',
          mostrar: true,
          value: true,
          on: 'PDF',
          off: '---',
          apiEnv: 'pdf',
          onChange: this.dfExpFormOnChangeValue
        },
        relatorio: {
          id: 'df-exp-form--relatorio',
          status: '',
          nome: '',
          mostrar: true,
          value: true,
          on: 'Relatório',
          off: '---',
          apiEnv: 'relatorio',
          onChange: this.dfExpFormOnChangeValue
        },
        password: {
          id: 'df-exp-form--password',
          status: '',
          nome: 'Senha',
          type: 'password',
          value: '',
          apiEnv: 'password',
          onChange: this.dfExpFormOnChangeValue
        },
        assunto: {
          id: 'df-exp-form--assunto',
          status: '',
          nome: 'Assunto',
          value: '',
          apiEnv: 'assunto',
          onChange: this.dfExpFormOnChangeValue
        },
        conteudo: {
          id: 'df-exp-form--conteudo',
          status: '',
          nome: 'Mensagem',
          config: {
            removeButtons: 'Save,NewPage,Preview,Print,Templates,About,ShowBlocks,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,Subscript,Superscript,Blockquote,CreateDiv,Outdent,Indent,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format',
            toolbarGroups: [
              { name: 'tools', groups: [ 'tools' ] },
              { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
              { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
              { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
              { name: 'forms', groups: [ 'forms' ] },
              { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
              { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
              { name: 'links', groups: [ 'links' ] },
              { name: 'insert', groups: [ 'insert' ] },
              { name: 'styles', groups: [ 'styles' ] },
              { name: 'colors', groups: [ 'colors' ] },
              { name: 'others', groups: [ 'others' ] },
              { name: 'about', groups: [ 'about' ] }
            ],
            height: '80'
          },
          apiEnv: 'conteudo',
          value: '',
          onChange: this.dfExpFormOnChangeValue
        }
      },
      botoes: {
        cancelar: {
          status: '',
          id: 'df-exp-form-botoes--cancelar',
          texto: 'Cancelar',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          onClick: () => { this.dfExpFormFechar(false) }
        },
        salvar: {
          status: '',
          id: 'df-exp-form-botoes--salvar',
          texto: 'Salvar',
          class: [ 'btn', 'btn-primary' ],
          mostrar: true,
          onClick: () => { this.dfExpFormSalvar() }
        }
      }
    }
  },
  mounted: function () {
    this.dfExpFormIniciar()
  },
  methods: {
    dfExpFormIniciar: function () {
      // VERIFICA SE ESTÁ EDITANDO ALGUM REGISTRO
      if (this.cpntId >= 1) {
        // SETA O STATUS DA PAGINA
        this.dfExpFormSetarStatusGeral('carregando')

        // BUSCA OS DADOS PARA O FORMULARIO
        this.dfExpFormBuscaDados(this.cpntId, (retorno) => {
          // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
          var chaves = Object.keys(this.campos)

          // RODA O VETOR DOS CAMPOS
          for (var indexC in chaves) {
            // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
            var chave = chaves[indexC]

            // SETA OS VALORES DO CAMPO
            this.dfExpFormSetarValorCampo(chave, retorno)

            // SETA O VALOR INICIAL DO CAMPO
            this.campos[chave].valueIni = this.campos[chave].value
          }

          // CHAMA A FUNÇÃO PARA FINALIZAR O CARREGAMENTO
          this.dfExpFormFinalizarCarregamento()
        })
      } else {
        // SETA O CONTEUDO DO CAMPO
        this.campos.assunto.value = 'Doc. Fiscal #meu.empresa.res# #exp.periodo#'

        // SETA O CONTEUDO DO CAMPO
        this.campos.conteudo.value = '<p>Prezado Contador,</p><p>Segue o link para baixar as notas fiscais referente ao período <b>#exp.periodo#</b>.<br/><table><tr><td style="width:70px;height:30px">Empresa:</td><td style="height:30px"><b>#meu.empresa#</b></td></tr><tr><td style="height:30px">CNPJ:</td><td> #meu.cnpj#</td></tr><tr><td>Link:</td><td>#exp.link#</td></tr></table>'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA FINALIZAR O CARREGAMENTO
        this.dfExpFormFinalizarCarregamento()
      }
    },
    dfExpFormFinalizarCarregamento: function () {
      // SETA O STATUS DA TELA
      this.dfExpFormSetarStatusGeral('')
    },
    dfExpFormSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    dfExpFormBuscaDados: function (id, callback) {
      // SETA O QUERY GET NA API
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

      // SETA OS CAMPOS QUE DEVE BUSCAR
      queryGet.field = {
        id: null,
        per_ini: null,
        per_fin: null,
        id_con: null,
        pdf: null,
        xml: null,
        relatorio: null,
        id_des: null,
        assunto: null,
        conteudo: null,
        password: null,
        status: null,
        id_clu_dependente: null,
        last_user: { j: { usuario: null } },
        last_at: null
      }

      // COMUNICA COM A API
      this.$store.state.comunicaAPI('/df/exp/get', 'POST', queryGet, (retorno) => {
        callback(retorno.data[0])
      }, this.dfExpFormSetarStatusGeral)
    },
    dfExpFormSetarValorCampo: function (chave, dados) {
      // INICIA A VARIAVEL DE VALOR
      var value = ''
      var valueRef = ''
      var options = null

      // VERIFICA O VALOR QUE DEVE SELECIONAR
      switch (chave) {
        case 'id_con':
          value = [ '', null, undefined, 't', '__TODOS__' ].indexOf(dados[chave]) !== -1 ? '__TODOS__' : dados[chave].split(',')
          break

        case 'id_des':
          value = dados[chave].split(',')
          break

        case 'per_ini':
        case 'per_fin':
          value = dados[chave + '_ptbr']
          break

        case 'contador':
          value = [ '', null, undefined ].indexOf(dados.id_clu_dependente) === -1
          break

        case 'xml':
        case 'pdf':
        case 'relatorio':
          value = [ '', null, undefined, '0', 0 ].indexOf(dados[chave]) === -1
          break

        default:
          value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
          break
      }

      // CONVERTE EM NUMERO OS VALORES RECEBIDOS
      if ([ 'id_con', 'id_des' ].indexOf(chave) !== -1 && typeof value === 'object') {
        for (var index in value) {
          value[index] = value[index].toString()
        }
      }

      // PEGA OS OPTIONS DO CAMPO
      if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
        options = this.campos[chave].options
      }

      // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
      if (options !== null && options.length >= 1 && typeof value === 'string') {
        // PEGA O VALOR DO CAMPO
        var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

        // SETA O VALOR ENCONTRADO
        value = valor.length === 1 ? valor[0] : value
      }       

      // SETA O VALOR ATUALIZADO DO CAMPO
      this.$set(this.campos[chave], 'value', value)
      this.$set(this.campos[chave], 'valueRef', valueRef)

      // VERIFICA SE TEM VALOR PARA ATUALIZAR
      if (options !== null) {
        this.$set(this.campos[chave], 'options', options)
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    dfExpFormFechar: function (atualizar) {
      // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
      this.cpntFecharFormulario(atualizar)

      // VERIFICA SE DEVE MUDAR A ROTA DO VUE
      if (this.$route.name === 'df_exp_form') {
        this.$router.push({ name: 'df_exp', params: {} })
      }
    },
    dfExpFormOnChangeValue: function (value, id) {
      // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
      var indexF = id.split('--')

      // SETA O VALOR RECEBIDO
      this.$set(this.campos[indexF[1]], 'value', value)

      // LIMPA O CAMPO DE MENSAGEM DE ERRO
      this.$set(this.campos[indexF[1]], 'mensagem', '')

      // LIMPA O CAMPO DE MENSAGEM DE ERRO
      this.$set(this.campos[indexF[1]], 'class', '')
    },
    dfExpFormOnNovoContato: function (chave) {
      // INICIA OS PARAMETROS
      var params = { tipo: 'contato', id: 0, editar: true }

      // SETA O CALLBACK QUE DEVE EXECUTAR
      params.callback = (atualizar, id) => {
        if (atualizar === true) {
          // SETA O VALOR PARA O CAMPO
          var valor = [ '', null, undefined ].indexOf(this.campos[chave].value) === -1 ? this.campos[chave].value : []

          // ADICIONA O ID RECEBIDO NO VETOR
          valor.push(id)

          // SETA OS NOVOS VALORES DO CAMPO
          this.campos[chave].value = valor

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      }

      // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
      this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
    },
    dfExpFormSalvar: function () {
      // SETA OS VALORES RECEBIDOS
      this.$set(this.botoes.salvar, 'status', 'carregando')

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
      const finalizacao = () => {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }

      // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
      const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

      // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
      FUN_MONTAR_FORMDATA_API(this.campos, { check_ini: false }).then((formData) => {
        // VERIFICA SE DEVE CONVERTER O VALOR
        if (formData.id_con === '__TODOS__') {
          formData.id_con = [ 't' ]
        }
        if (formData.id_des === '__TODOS__') {
          formData.id_des = [ 't' ]
        }

        // CONVERTE O VETOR EM JSON STRING
        if (typeof formData.id_con === 'object') {
          formData.id_con = formData.id_con.join()
        }
        if (typeof formData.id_des === 'object') {
          formData.id_des = formData.id_des.join()
        }

        // SETA QUE SERÁ UMA ATUALIZAÇÃO
        var method = 'POST'
        
        // VERIFICA SE TEM AGUM REGISTRO PARA ATUALIZAR
        if (typeof this.cpntId === 'object' || this.cpntId !== 0) {
          // SETA O ID QUE DEVE ATUALIZAR
          formData.id = this.cpntId.toString()

          // SETA QUE SERÁ UMA ATUALIZAÇÃO
          method = 'PUT'
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/df/exp', method, formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)
          
          // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
          this.dfExpFormFechar(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
        }, this.dfExpFormSetarStatusGeral, (apiValid, apiStatus) => { this.dfExpFormTratarValidacao(apiValid, apiStatus, finalizacao) })
      })
    },
    dfExpFormTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
      // SETA O STATUS DA TELA
      this.dfExpFormSetarStatusGeral('')

      // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
      const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

      // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
      FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {        
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      })
    },
  }
}
</script>
